var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoPoBox(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "25px",
    height: "27px",
    viewBox: "0 0 25 27",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DDF7F228-0AF2-44E0-B860-F92B616FD7B3") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-554.000000, -739.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "po-box",
    transform: "translate(555.311035, 740.543701)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9421387,17.9138184 L10.9421387,8.44824219 L10.9421387,8.44824219 C10.1469393,5.42048888 7.04782379,3.61064633 4.02007048,4.40584572 C2.13685872,4.9004464 0.639321802,6.32702769 0.0539623141,8.18403351 L0,8.35522461 L0,17.9138184 L21.8842773,17.9138184 L21.8842773,9.30698631 C21.8842773,8.74576033 21.7268487,8.19578767 21.4298819,7.71956787 L20.8378941,6.77024852 C20.1685825,5.69693196 19.0958401,4.93778873 17.8610077,4.6636076 L16.8030412,4.42869764 C16.1625048,4.28647348 15.5083361,4.21472168 14.8522,4.21472168 L5.01757812,4.21472168",
    id: "Path-66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9421387,25.4562988 L13.9421387,18",
    id: "Path-67"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-67",
    points: "15.9421387 7.91259766 15.9421387 -1.00808251e-13 20.8613281 -4.39251534e-14"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPoBox);
export default __webpack_public_path__ + "static/media/ico_po-box.835bb7678baf2775ad98fe6b645f80db.svg";
export { ForwardRef as ReactComponent };